import { render, staticRenderFns } from "./projectApplyDetail.vue?vue&type=template&id=31855f8d&scoped=true"
import script from "./projectApplyDetail.vue?vue&type=script&lang=js"
export * from "./projectApplyDetail.vue?vue&type=script&lang=js"
import style0 from "./projectApplyDetail.vue?vue&type=style&index=0&id=31855f8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31855f8d",
  null
  
)

export default component.exports